// extracted by mini-css-extract-plugin
export default {"p":"_6844c6fd82 _3157207ef3 _88975a9f66","clr":"_9501817515","dls":"_6d3d93c574"};